import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import {
  FolderOpen,
  Layers,
  FileUp,
  UserPlus,
  MessageSquare
} from 'lucide-react';

const steps = [
  {
    number: 1,
    icon: FolderOpen,
    title: 'Crear un Proyecto',
    description: 'Ve a la sección de Proyectos y crea un nuevo proyecto. Un proyecto agrupa toda la información y documentos relacionados con un tema o cliente específico.'
  },
  {
    number: 2,
    icon: Layers,
    title: 'Crear Áreas dentro del Proyecto',
    description: 'Dentro de cada proyecto, crea áreas para organizar los documentos por categorías o temas. Por ejemplo: "Contratos", "Manuales", "FAQs".'
  },
  {
    number: 3,
    icon: FileUp,
    title: 'Subir Documentos a las Áreas',
    description: 'Sube archivos PDF, DOCX, TXT o MD a cada área. Estos documentos serán procesados y divididos en fragmentos para que el asistente pueda consultarlos.'
  },
  {
    number: 4,
    icon: UserPlus,
    title: 'Crear Usuarios y Asignarles Proyectos',
    description: 'Crea cuentas de usuario y asígnales los proyectos a los que tendrán acceso. Cada usuario solo podrá consultar los documentos de sus proyectos asignados.'
  },
  {
    number: 5,
    icon: MessageSquare,
    title: 'Los Usuarios van al Chat a Hacer Preguntas',
    description: 'Los usuarios inician sesión, seleccionan su proyecto y hacen preguntas en el chat. El asistente busca en los documentos del proyecto y responde con información relevante.'
  }
];

function TutorialPage() {
  return (
    <AdminLayout
      title={<h1>Tutorial</h1>}
    >
      <div className="tutorial-page-content">
        <div className="tutorial-header">
          <h2>Primeros Pasos</h2>
          <p>Sigue estos 5 pasos para configurar tu asistente de chat con RAG</p>
        </div>

        <div className="tutorial-steps">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.number} className="tutorial-card">
                <div className="tutorial-card-number">{step.number}</div>
                <div className="tutorial-card-icon">
                  <Icon size={28} />
                </div>
                <div className="tutorial-card-body">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </AdminLayout>
  );
}

export default TutorialPage;
